import { useHomeSearchSettingsContext } from "@pages/Home/HomeContext";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";
import { useEffect } from "react";

export function useSelectedKeywordsSettings() {
    const { data } = useHomeSearchSettingsContext();
    const {
        setIsSelectedKeywordsView,
        setSelectedKeywordsIds,
    } = useSelectedKeywordsContext();

    useEffect(() => {
        if (data?.keywordsIds?.length) {
            setSelectedKeywordsIds(data.keywordsIds);
            setIsSelectedKeywordsView(true);
        }
    }, [data?.keywordsIds, setIsSelectedKeywordsView, setSelectedKeywordsIds]);
}